import { apiBase, fetchUsingApi } from "../core/apiClient";

export interface UserResponse {
  id: number;
  email: string;
}

export const findUserByEmail = async (email: string, buildingId: number) => {
  const response = await fetchUsingApi<UserResponse>(
    `${apiBase}/user/v1/find-by-email?email=${email}&buildingId=${buildingId}`,
    "GET",
    (e) => e as UserResponse,
  );

  return response;
};
